import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const slice = createSlice({
    name: "pickup",
    initialState: {
        isLoading: false,
        error: null,
        // ----------------------------------
        pickupFilter: {
            status: "all",
            order_by: false,
            keyword: "",
            start_day: "",
            end_day: "",
            //
            page: 1,
            page_size: 100,
            total: 0
        }
    },
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        hasError(state, action) {
            state.error = action.payload;
        },

        clearError(state) {
            state.error = null;
        },

        updatePickupListFilter(state, action) {
            state.pickupFilter = {
                ...state.pickupFilter,
                ...action.payload
            };
        },

        resetPickupListFilter(state) {
            state.pickupFilter = {
                ...state.pickupFilter,
                //
                status: "all",
                order_by: false,
                keyword: "",
                start_day: "",
                end_day: "",
                page: 1
            };
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    updatePickupListFilter,
    resetPickupListFilter,
    //
    clearError
} = slice.actions;

// ----------------------------------------------------------------------
